export default __webpack_public_path__ + "static/media/notif_sound.264b8e41.mp3";